import { ReactNode, createContext } from "react";
import useDespesasVendedor, { DespesasVendedorType, CreateDespesasVendedorType, UpdateDespesasVendedorType } from "./hooks/useDespesasVendedor";

interface DespesasVendedorContextProviderProps {
    children: ReactNode;
}

export interface DespesasVendedorContextData {
    getAllDespesasVendedorPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<DespesasVendedorType[] | null>;
    setDespesasVendedor: any;
    despesasVendedor: DespesasVendedorType;
    setListDespesasVendedor: any;
    listDespesasVendedor: DespesasVendedorType[];
    setInitialListDespesasVendedor: any;
    initialListDespesasVendedor: DespesasVendedorType[];
    setDespesasVendedorPageCount: any;
    despesasVendedorPageCount: number;
    createDespesasVendedor: (createDespesasVendedorType: CreateDespesasVendedorType) => Promise<CreateDespesasVendedorType | null>;
    updateDespesasVendedor: (updateDespesasVendedorType: UpdateDespesasVendedorType) => Promise<UpdateDespesasVendedorType | null>;
    deleteDespesasVendedor: (id: number) => Promise<DespesasVendedorType | null>;
    handleGetDespesasVendedorByEmpresaId: (empresaId: number) => Promise<DespesasVendedorType[] | null>;
    listDespesasVendedorByEmpresa: DespesasVendedorType[];
    setListDespesasVendedorByEmpresa: any;
    aprovarDespesasVendedor: (id: number) => Promise<boolean>;
    rejeitarDespesasVendedor: (id: number) => Promise<boolean>;
    fetchExpenseAttachment: (despesaId: number) => Promise<any>;
    downloadExpenseAttachment: (despesaId: number) => Promise<void>;
}

const initialState: DespesasVendedorContextData = {
    getAllDespesasVendedorPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setDespesasVendedor: () => { },
    despesasVendedor: {
        id: 0,
        description: "",
        value: 0,
        date: "",
        observation: "",
        status: 0,
        vendedorId: 0,
        tipoDespesasVendedorId: 0,
        tipoDespesasVendedorName: "",
        tipoDespesasVendedorIcon: "",
    },
    setListDespesasVendedor: () => { },
    listDespesasVendedor: [],
    setInitialListDespesasVendedor: () => { },
    initialListDespesasVendedor: [],
    setDespesasVendedorPageCount: () => { },
    despesasVendedorPageCount: 0,
    createDespesasVendedor: async (createDespesasVendedorType: CreateDespesasVendedorType) => {
        return Promise.resolve(null);
    },
    updateDespesasVendedor: async (updateDespesasVendedorType: UpdateDespesasVendedorType) => {
        return Promise.resolve(null);
    },
    deleteDespesasVendedor: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetDespesasVendedorByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listDespesasVendedorByEmpresa: [],
    setListDespesasVendedorByEmpresa: () => { },
    aprovarDespesasVendedor: async (id: number) => {
        return Promise.resolve(false);
    },
    rejeitarDespesasVendedor: async (id: number) => {
        return Promise.resolve(false);
    },
    fetchExpenseAttachment: async (despesaId: number) => {
        return Promise.resolve(null);
    },
    downloadExpenseAttachment: async (despesaId: number) => {
        return Promise.resolve();
    },
};

export const DespesasVendedorContext =
    createContext<DespesasVendedorContextData>(initialState);

export default function DespesasVendedorContextProvider({
    children,
}: DespesasVendedorContextProviderProps) {
    const {
        getAllDespesasVendedorPaged,
        createDespesasVendedor,
        updateDespesasVendedor,
        deleteDespesasVendedor,
        despesasVendedor,
        setDespesasVendedor,
        setListDespesasVendedor,
        listDespesasVendedor,
        initialListDespesasVendedor,
        setInitialListDespesasVendedor,
        setDespesasVendedorPageCount,
        despesasVendedorPageCount,
        handleGetDespesasVendedorByEmpresaId,
        listDespesasVendedorByEmpresa,
        setListDespesasVendedorByEmpresa,
        aprovarDespesasVendedor,
        rejeitarDespesasVendedor,
        fetchExpenseAttachment,
        downloadExpenseAttachment,
    } = useDespesasVendedor();

    return (
        <DespesasVendedorContext.Provider
            value={{
                getAllDespesasVendedorPaged,
                createDespesasVendedor,
                updateDespesasVendedor,
                deleteDespesasVendedor,
                despesasVendedor,
                setDespesasVendedor,
                setListDespesasVendedor,
                listDespesasVendedor,
                initialListDespesasVendedor,
                setInitialListDespesasVendedor,
                setDespesasVendedorPageCount,
                despesasVendedorPageCount,
                handleGetDespesasVendedorByEmpresaId,
                listDespesasVendedorByEmpresa,
                setListDespesasVendedorByEmpresa,
                aprovarDespesasVendedor,
                rejeitarDespesasVendedor,
                fetchExpenseAttachment,
                downloadExpenseAttachment,
            }}
        >
            {children}
        </DespesasVendedorContext.Provider>
    );
}
